// A LiveView brings an element into sight after a patch with
// `push_event(socket, "scroll-into-view", %{id: id})`, e.g. a form that opens
// below a long list. LiveView dispatches pushed events after it patches the
// page, so the element is already there.
export function scrollToPushedElement(event: Event) {
  const detail = (event as CustomEvent<{ id?: string }>).detail
  const element = detail?.id ? document.getElementById(detail.id) : null

  if (!element) {
    return
  }

  element.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

export function listenForScrollIntoView() {
  window.addEventListener('phx:scroll-into-view', scrollToPushedElement)
}
